import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2cd1814a")

_pushScopeId("data-v-2cd1814a")
const _hoisted_1 = { class: "gauge" }
const _hoisted_2 = { class: "inner-gauge" }
const _hoisted_3 = {
  class: "gauge-fill",
  height: "20rem",
  width: "20rem"
}
const _hoisted_4 = {
  class: "gauge-fill-path",
  d: "M25,100a75,75 0 1,0 150,0a75,75 0 1,0 -150,0",
  "stroke-linecap": "round",
  ref: "gaugeFillPath"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.percentComplete) + "%", 1)
    ]),
    (_openBlock(), _createBlock("svg", _hoisted_3, [
      _createVNode("path", _hoisted_4, null, 512)
    ]))
  ]))
})